/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	SpaceRolesByCriteriaQuery$data as SpaceRolesByCriteriaQuery,
	SpaceRolesByCriteriaQuery$variables as SpaceRolesByCriteriaQueryVariables,
} from '../__generated__/SpaceRolesByCriteriaQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { SpaceRolesByCriteriaQuery$data } from '../__generated__/SpaceRolesByCriteriaQuery.graphql.ts';
export type SpaceRolesByCriteriaQuery_spaceRolesByCriteria_SpaceRoleConnection_nodes_SpaceRole_spacePermissionList_SpacePermissionInfo = NonNullable<NonNullable<NonNullable<SpaceRolesByCriteriaQuery$data['spaceRolesByCriteria']>['nodes'][number]>['spacePermissionList'][number]>;
export type SpaceRolesByCriteriaQuery_spaceRolesByCriteria_SpaceRoleConnection_nodes_SpaceRole = NonNullable<NonNullable<SpaceRolesByCriteriaQuery$data['spaceRolesByCriteria']>['nodes'][number]>;
export type SpaceRolesByCriteriaQuery_spaceRolesByCriteria_SpaceRoleConnection_pageInfo_SpaceRolePageInfo = NonNullable<NonNullable<SpaceRolesByCriteriaQuery$data['spaceRolesByCriteria']>['pageInfo']>;
export type SpaceRolesByCriteriaQuery_spaceRolesByCriteria_SpaceRoleConnection = NonNullable<SpaceRolesByCriteriaQuery$data['spaceRolesByCriteria']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum ConfluenceRoleAssignabilityCode {
  ASSIGNABLE = "ASSIGNABLE",
  DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED = "DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED",
  ESCALATION_NOT_ASSIGNABLE = "ESCALATION_NOT_ASSIGNABLE",
  GUEST_EXISTING_SPACE_ACCESS = "GUEST_EXISTING_SPACE_ACCESS",
  GUEST_SYSTEM_SPACE_ACCESS = "GUEST_SYSTEM_SPACE_ACCESS",
  NOT_ASSIGNABLE = "NOT_ASSIGNABLE",
  NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE = "NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE",
  NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE = "NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE",
  PRINCIPAL_INVALID_ROLE = "PRINCIPAL_INVALID_ROLE",
}

export enum RoleAssignmentPrincipalType {
  ACCESS_CLASS = "ACCESS_CLASS",
  APP = "APP",
  GROUP = "GROUP",
  USER = "USER",
}

export enum SpaceRoleType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}


// Note: Original file contained additional custom exports that need manual review:
// RoleAssignmentPrincipalInput
// Please verify these are handled correctly in your codebase.
